import React from "react";
import ConfigSection from "../../ConfigSection";

const AssetSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Asset'
      configType='Asset'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default AssetSection;
